module.exports = __webpack_public_path__ + "static/media/eyelash-3.b6df6fcc.png";